<template>
  <div
    :class="[
      'seckill',
      rowClass,
      linkValue ? 'has-arrow' : ''
    ]"
    v-if="show"
  >
    <div class="header">
      <div class="left">
        <img
          class="image"
          src="https://img.chinabeego.com/uploadfile/2022/8/20/16609831372841490127969636192.png"
        />
        <div class="count-down" v-if="showCountDown">
          <span class="count">{{ timeData.hours }}</span>
          <span class="split">:</span>
          <span class="count">{{ timeData.minutes }}</span>
          <span class="split">:</span>
          <span class="count">{{ timeData.seconds }}</span>
        </div>
      </div>
      <div class="middle">
        <div class="scroll" ref="scroll">
          <div
            :class="['tab', index === tab.index ? 'active' : '']"
            v-for="(item, index) of tab.list"
            :style="{
              width: tab.width + 'px',
              marginRight: tab.marginRight + 'px'
            }"
            :key="index"
            @click="updateGoodsList(item, index)"
          >
            <div class="date">{{ item.$startTime }}</div>
            <div class="time">{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div class="right" v-if="linkValue" @click="onArrowClick">
        <img
          class="arrow-icon"
          src="https://img.chinabeego.com/uploadfile/2022/8/20/16609831508141490141499973498.png"
          alt=""
        />
      </div>
    </div>
    <div class="goods-container">
    <div class="goods-box">
      <div
        :class="['goods', `goods-${item.$status}`]"
        v-for="(item, index) of list"
        :key="item.goodsId"
        @click="onItemClick(item, index)"
      >
        <div class="left">
          <van-image
            class="goods-image"
            :src="item.indexImageUrl"
            lazy-load
            fit="cover"
          >
            <template v-slot:loading>
              <img :src="loadingImg" />
            </template>
            <template v-slot:error>
              <img :src="loadingImg" />
            </template>
          </van-image>
        </div>
        <div class="right">
          <div class="name">{{ item.goodsName }}</div>
          <div class="sub-title" v-show="show.subTitle">
            {{ item.sellProp }}
          </div>
          <div class="view1">
            <div class="price">¥{{ item.goodsPrice }}</div>
            <div class="marking-price" v-show="show.markingPrice">
              ¥{{ item.markingPrice }}
            </div>
          </div>
          <div class="view2">
            <div class="progress-box">
              <div class="stock">{{ item.$stock }}</div>
              <div class="progress">
                <div class="inner" :style="{ width: `${item.$percentage}` }" />
              </div>
            </div>
            <div
              class="btn"
              v-show="show.btn"
              @click.stop="onButtonClick(item, index)"
            >
              <div class="tag" v-show="item.$tag">{{ item.$tag }}</div>
              {{ item.$buttonName }}
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import utils from '@/utils/common';
import http from '@/utils/axios';
import { navigateTo } from '@/views/activities/utils';
export default {
  props: {
    floor: Object,
    home: Object
  },
  data() {
    return {
      show: undefined,
      list: [],
      rows: {
        1: 'one',
        2: 'two',
        3: 'three'
      },
      tab: {
        list: [],
        index: 0,
        width: Number(utils.rem2px(112, false)),
        marginRight: Number(utils.rem2px(16, false))
      },
      linkValue: undefined,
      timeData: {},
      showCountDown: false,
      rowClass: '',
      loadingImg:
        this.$theme.u_goods_icon_default || require('@/assets/loadingBG.png')
    };
  },
  created() {
    this.init();
  },
  methods: {
    /**
     * 使用this.$set会触发watch
     * 所以用if(this.unwatch) this.unwatch() 和
     * this.unwatch = this.$watch('floor', this.init)
     * 包裹代码保证每次执行只触发一次
     */
    init() {
      if (this.unwatch) this.unwatch();
      this.normalizeFloor();
      this.unwatch = this.$watch('floor', this.init);
    },
    normalizeFloor() {
      const { floor, home, tab } = this;
      Object.assign(floor, home.seckillComponent);
      tab.list = this.normalizeTabs(floor.seckillActivityList);
      tab.index = Math.max(
        tab.list.findIndex((item) => item.isSelect === 1),
        0
      );
      const list = tab.list[tab.index].seckillActivityGoodsList;
      const l = floor.seckillComponentStyle2;
      this.linkValue = l && l.linkValue;
      this.update(list);
    },
    normalizeTabs(tabs) {
      tabs.forEach((item) => {
        try {
          const [year, month, day] = item.startTime.split(' ')[0].split('-');
          this.$set(item, '$startTime', `${Number(month)}月${day}日`);
        } catch (e) {}
      });
      return tabs;
    },
    normalizeList(list) {
      const tab = this.tab.list[this.tab.index];
      const button = {
        names: {
          1: '去看看',
          2: '去抢购',
          3: '提醒我',
          4: '取消提醒'
        },
        status: {
          1: 'over',
          2: 'started',
          3: 'unstart',
          4: 'unstart-reminded'
        }
      };
      const toNumber = (v) => {
        v = Number(v);
        return isNaN(v) ? 0 : v;
      };
      list.forEach((item) => {
        const status = button.status[item.buttonStatus];
        let tag = '';
        let stock = '';
        let percentage = '';
        switch (status) {
          case 'started':
            const total = toNumber(item.totalStock);
            const current = toNumber(item.currentStock);
            percentage = `${((current / total) * 100).toFixed(0)}%`;
            tag = '进行中';
            stock = `仅剩${current}份`;
            break;
          case 'over':
            percentage = '0%';
            stock = '仅剩0份';
            tag = '';
            break;
          default:
            percentage = '100%';
            tag = tab.$startTime;
            stock = '即将开始';
            break;
        }
        this.$set(item, '$status', status);
        this.$set(item, '$tag', tag);
        this.$set(item, '$stock', stock);
        this.$set(item, '$percentage', percentage);
        this.$set(item, '$buttonName', button.names[item.buttonStatus]);
      });
      return list;
    },
    normalizeShow() {
      const display = this.floor.$display;
      const row = this.rows[this.list.length];
      const show = {
        subTitle: true,
        markingPrice: display.seckillMarkingPrice,
        stock: display.seckillStock,
        btn: true
      };
      switch (row) {
        case 'two':
          show.subTitle = false;
          show.markingPrice = false;
          show.btn = false;
          break;
      }
      return show;
    },
    setTime() {
      const { floor, tab } = this;
      const oneHundredHours = 60 * 60 * 100 * 1000; // 一百小时
      const item = tab.list[tab.index];
      const time = item.nextStartMillisecond;
      this.showCountDown = floor.showCountDown === 1 && time < oneHundredHours;
      this.startedCountDown(time);
    },
    async scrollTo() {
      if (!this.$refs.scroll) {
        await this.$nextTick();
      }
      const { tab } = this;
      const { scroll } = this.$refs;
      const margin = tab.index ? tab.marginRight * (tab.index - 1) : 0;
      scroll.scrollLeft = tab.width * tab.index + margin - 10;
    },
    startedCountDown(time) {
      if (!this.showCountDown) return;
      clearInterval(this.timer);
      time = time / 1000;
      const addZero = (n) => (n < 10 ? '0' + n : n);
      const run = (s) => {
        if (!s) {
          clearInterval(this.timer);
          this.showCountDown = false;
          return;
        }
        this.timeData = {
          hours: addZero(Math.floor(s / (60 * 60))),
          minutes: addZero(Math.floor((s % (60 * 60)) / 60)),
          seconds: addZero(Math.floor(s % 60))
        };
      };
      this.timer = setInterval(() => run(--time), 1000);
      run(time);
    },
    update(list) {
      this.list = this.normalizeList(list);
      this.show = this.normalizeShow();
      this.rowClass = `row-${this.rows[this.list.length] || 'three'}`;
      this.setTime();
      this.scrollTo();
    },
    updateGoodsList(item, index) {
      if (index === this.tab.index) return;
      this.tab.index = index;
      http({
        url: '/order/app/seckill/getGoodsList',
        method: 'POST',
        parmes: {
          startTime: item.startTime,
          endTime: item.endTime
        }
      }).then((data) => {
        if (data.code === 200 && (data = data.data)) {
          this.update(data);
        }
      });
    },
    onArrowClick() {
      navigateTo(this, {
        pageLinkType: 11,
        pageLinkValue: this.linkValue
      })
    },
    onItemClick(item, index) {
      this.$emit('jump', { item, index });
    },
    onButtonClick(item, index) {
      if (item.$status === 'unstart') {
        http({
          url: `order/user/seckill/follow/${item.seckillId}`,
          method: 'put'
        }).then((rps) => {
          if (rps.code == 200) {
            this.$loading.hide();
            Toast({
              message: '设置成功！将在开抢5分钟前提醒您！',
              duration: 1000
            });
            this.$emit('call', { fn: 'reloadData' });
          }
        });
      } else if (item.$status === 'unstart-reminded') {
        http({
          url: `order/user/seckill/unfollow/${item.seckillId}`,
          method: 'put'
        }).then((rps) => {
          if (rps.code == 200) {
            this.$loading.hide();
            Toast({
              message: '秒杀提醒已取消，您可能会抢不到哦！',
              duration: 1000
            });
            this.$emit('call', { fn: 'reloadData' });
          }
        });
      } else {
        this.onItemClick(item, index);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import url('./style-three.less');
</style>
